import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import Loader from "components/Loader";
import AboutUs from "components/layout/AboutUs";
import SidebarInsurances from "components/layout/outer-header/SidebarInsurances";
import { SidebarWorkingConditions } from "components/layout/outer-header/SidebarWorkingConditions";
import Business from "components/layout/outer-header/business/Business";
import FeaturesPage from "components/features/FeaturesPage";
import HowItWorks from "views/HowItWorks";
import ContactUs from "components/layout/contact-us/ContactUs";
import BussinesInfo from "components/layout/outer-header/BussinesInfo";
import CompareDiffForms from "components/layout/outer-header/CompareDiffForms";
import WorkingAsFreelancer from "components/layout/outer-header/WorkingAsFreelancer";
import InvoiceWithoutCompany2025 from "components/layout/outer-header/InvoiceWithoutCompany2025";
import CompanyReview from "views/dashboard/seo-files/company-review/CompanyReview";
import { InvoicingSelfEmployed } from "views/dashboard/seo-files/InvoicingSelfEmployed";
import { FreelanceFreelancing } from "views/dashboard/seo-files/FreelanceFreelancing";
import ApprovalNotifyPage from "components/ApprovalNotifyPage";
import Unsubscribed from "components/Unsubscribed";
import AuthorizedForReminder from "components/AuthorizedForReminder";
import CookiesPage from "components/layout/outer-header/cookiesPage";
import Ambassador from "components/layout/Ambassador";
import SelfEmployment from "components/layout/outer-header/SelfEmployment";
import InfoInspiration from "components/layout/outer-header/InfoInspiration";
import Negotiation from "components/layout/outer-header/Negotiation";
import GiggerVsInvozio from "views/dashboard/seo-files/comparison/GiggerVsInvozio";
import FrilansVsInvozio from "views/dashboard/seo-files/comparison/FrilansVsInvozio";
import CoolCompanyVsInvozio from "views/dashboard/seo-files/comparison/CoolCompanyVsInvozio";
import Error from "views/Error";
import DashboardView from "views/dashboard";
import PrivateCareInsurance from "components/layout/outer-header/PrivateCareInsurance";
import PensionInsurance from "components/layout/outer-header/PensionInsurance";
import ManinHealthInsurance from "components/layout/outer-header";
import HealthInsurance from "components/layout/outer-header/HealthInsurance";
import { InvoiceAsConsultant } from "components/layout/outer-header/InvoiceAsConsultant";
import { InvoiceWithoutCompany } from "components/layout/outer-header/InvoiceWithoutCompany";
import { LOCALES } from "common/constants";
import { lazyWithRetry } from "common/lazyWithRetry";

const Faq = lazyWithRetry(() => import("../views/dashboard/Faq"));
// const DashboardView = lazyWithRetry(() => import("../views/dashboard"));
const HomePage = lazyWithRetry(() => import("../views/index"));

export const Router = ({ mobileScreen, dashboardFooter, language }) => {
  return (
    <Routes>
      {/* Mobile Screen Pages Start */}
      <Route
        exact
        path="/mobile_faq"
        element={
          <Suspense
            fallback={
              <div>
                <Loader />
              </div>
            }
          >
            <Faq mobileScreen={mobileScreen} />
          </Suspense>
        }
      />
      <Route
        exact
        path="/mobile_about_us"
        element={<AboutUs mobileScreen={mobileScreen} />}
      />
      <Route
        exact
        path="/mobile_Insurance_admin"
        element={<SidebarInsurances mobileScreen={mobileScreen} />}
      />
      <Route
        exact
        path="/mobile_goodworking_conditions"
        element={<SidebarWorkingConditions mobileScreen={mobileScreen} />}
      />
      <Route
        exact
        path="/mobile_business_solution"
        element={<Business dashboardFooter={dashboardFooter} />}
      />
      {/* Mobile Screen Pages End */}

      <Route
        exact
        path="/"
        element={
          <Suspense
            fallback={
              <div>
                <Loader />
              </div>
            }
          >
            <HomePage dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />

      <Route
        exact
        path={language === LOCALES.EN_US ? "/function" : "/funktion"}
        element={<FeaturesPage dashboardFooter={dashboardFooter} />}
      />

      <Route
        exact
        path="/faq"
        element={
          <Suspense
            fallback={
              <div>
                <Loader />
              </div>
            }
          >
            <Faq dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />
      <Route
        exact
        path={
          language === LOCALES.EN_US ? "/how-works-invozio" : "/hur-fungerar-invozio"
        }
        element={<HowItWorks dashboardFooter={dashboardFooter} />}
      />

      <Route
        exact
        path={language === LOCALES.EN_US ? "/about-invozio" : "/om-invozio"}
        element={<AboutUs dashboardFooter={dashboardFooter} />}
      />
      <Route
        exact
        path={language === LOCALES.EN_US ? "/contact-us" : "/kontakta-oss"}
        element={<ContactUs dashboardFooter={dashboardFooter} />}
      />
      <Route
        exact
        path={
          language === LOCALES.EN_US
            ? "/start-your-own-business-or-invoice-as-a-private-person"
            : "/starta-eget-foretag-eller-fakturera-som-privatperson"
        }
        element={<SidebarWorkingConditions dashboardFooter={dashboardFooter} />}
      />
      <Route
        exact
        path={language === LOCALES.EN_US ? "/dashboard/*" : "/instrumentbrada/*"}
        element={<DashboardView dashboardFooter={dashboardFooter} />}
      />
      <Route
        exact
        path={language === LOCALES.EN_US ? "/insurance" : "/forsakring"}
        element={<SidebarInsurances dashboardFooter={dashboardFooter} />}
      />

      <Route
        exact
        path={
          language === LOCALES.EN_US ? "/health-insurance-main" : "/sjukforsakring-huvud"
        }
        element={<ManinHealthInsurance dashboardFooter={dashboardFooter} />}
      />

      <Route
        exact
        path={language === LOCALES.EN_US ? "/health-insurance" : "/sjukforsakring"}
        element={<HealthInsurance dashboardFooter={dashboardFooter} />}
      />

      <Route
        exact
        path={
          language === LOCALES.EN_US
            ? "/private-healthcare-insurance"
            : "/privatvardsforsakring"
        }
        element={<PrivateCareInsurance dashboardFooter={dashboardFooter} />}
      />

      <Route
        exact
        path={language === LOCALES.EN_US ? "/pension" : "/pension"}
        element={<PensionInsurance dashboardFooter={dashboardFooter} />}
      />

      <Route
        exact
        path="/external-help-with-payroll-management"
        element={<BussinesInfo dashboardFooter={dashboardFooter} />}
      />
      <Route
        exact
        path={
          language === LOCALES.EN_US
            ? "/freelance-consultant-salary-invoice-without-a-company"
            : "/frilans-konsult-lon-fakturera-utan-foretag"
        }
        element={<CompareDiffForms dashboardFooter={dashboardFooter} />}
      />
      <Route
        exact
        path={
          language === LOCALES.EN_US
            ? "/invoicing-without-company-2025"
            : "/fakturering-utan-foretag-2025"
        }
        element={<InvoiceWithoutCompany2025 dashboardFooter={dashboardFooter} />}
      />
      <Route
        exact
        path={
          language === LOCALES.EN_US
            ? "/working-as-a-freelancer-and-invoicing-without-tax-registration"
            : "/att-jobba-som-frilansare-och-fakturera-utan-fskatt"
        }
        element={<WorkingAsFreelancer dashboardFooter={dashboardFooter} />}
      />
      <Route
        exact
        path="/recension-av-faktura-utan-foretag-frilansfinans-coolcompany-gigger"
        element={<CompanyReview />}
      />
      <Route exact path="/gigger-vs-Invozio" element={<GiggerVsInvozio />} />
      <Route
        exact
        path="/frilans-finans-vs-Invozio"
        element={<FrilansVsInvozio />}
      />
      <Route
        exact
        path="/cool-company-vs-Invozio"
        element={<CoolCompanyVsInvozio />}
        sines
      />
      <Route
        exact
        path={
          language === LOCALES.EN_US
            ? "/how-much-should-I-invoice-as-a-freelancer"
            : "/hur-mycket-ska-jag-fakturera-som-frilansare"
        }
        element={<InfoInspiration dashboardFooter={dashboardFooter} />}
      />
      <Route
        exact
        path={
          language === LOCALES.EN_US
            ? "/from-invoice-to-negotiation"
            : "/fran-faktura-till-forhandling"
        }
        element={<Negotiation dashboardFooter={dashboardFooter} />}
      />
      <Route
        exact
        path={language === LOCALES.EN_US ? "/business" : "/foretag"}
        element={<Business dashboardFooter={dashboardFooter} />}
      />
      <Route
        exact
        path={language === LOCALES.EN_US ? "/self-employment" : "/egenanstallning"}
        element={<SelfEmployment dashboardFooter={dashboardFooter} />}
      />
      <Route
        exact
        path={language === LOCALES.EN_US ? "/ambassador" : "/ambassador"}
        element={<Ambassador dashboardFooter={dashboardFooter} />}
      />
      <Route
        exact
        path="/cookies"
        element={<CookiesPage dashboardFooter={dashboardFooter} />}
      />
      <Route exact path="/error" element={<Error />} />

      <Route
        exact
        path={language === LOCALES.EN_US ? "/unsubscribed" : "/avprenumererad"}
        element={<Unsubscribed />}
      />
       <Route
        exact
        path={language === "en" ? "/authorize-reminder" : "/auktorisera-påminnelse"}
        element={<AuthorizedForReminder />}
      />
      <Route
        exact
        path={
          language === LOCALES.EN_US ? "/approval-notify" : "/godkannande-meddelande"
        }
        element={<ApprovalNotifyPage />}
      />
      <Route
        exact
        path={
          language === LOCALES.EN_US
            ? "/freelance-freelancing"
            : "/frilans-frilansarbete"
        }
        element={<FreelanceFreelancing dashboardFooter={dashboardFooter} />}
      />
      <Route
        exact
        path={
          language === LOCALES.EN_US
            ? "/invoicing-as-an-individual_self-employed"
            : "/fakturera-som-privatperson_egenanstalld"
        }
        element={<InvoicingSelfEmployed dashboardFooter={dashboardFooter} />}
      />
      <Route
        exact
        path={
          language === LOCALES.EN_US
            ? "/invoice-without-company-or-business"
            : "/fakturera-utan-foretag-eller-bolag"
        }
        element={<InvoiceWithoutCompany dashboardFooter={dashboardFooter} />}
      />
      <Route
        exact
        path={
          language === LOCALES.EN_US
            ? "/invoice-as-consultant-salary"
            : "/fakturera-som-konsult-lon"
        }
        element={<InvoiceAsConsultant dashboardFooter={dashboardFooter} />}
      />
    </Routes>
  );
};
